import React from "react";
import {Tabs, TabsProps} from "antd";
import Team from "./Team";
import Firm from "./Firm";
import Env from "./Env";

const Settings: React.FC = () => {

    const onChange = (key: string) => {
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Environment',
            children: <Env/>,
        },
        {
            key: '2',
            label: 'Équipes',
            children: <Team/>,
        },
        {
            key: '3',
            label: 'Sociétés',
            children: <Firm/>,
        },
    ];

    return (
        <div className="Settings">
            <h2>Settings</h2>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange}/>
        </div>
    );
}
export default Settings;